import mapFns from './map';
import globals from './globals';
import argParser from './argParser';
import './elementCreator';

var userTips, giHint, privateFns;

privateFns = {
	setSiteAttributes: function (params) {
		var target = $(".site-name");
		if (params.title) {
			target.find("h1").html(params.title);
		} else {
			target.find("h1").html("planinnsyn");
		}
		if (params.subTitle) {
			target.find("h1").addClass("subTitle").after("<br /><span>" + params.subTitle + "</span>");
		}
		if (params.customClass) {
			target.addClass(params.customClass);
		}
		if(params.titleLink){
			$("#titleLink")[0].href = params.titleLink;
		}
	},
	setColorScheme: function (colors){
		if(colors){
			Object.keys(colors).forEach(function(key){
				document.documentElement.style.setProperty('--'+key, colors[key]);
			});
		}
		var img = document.getElementById("osloLogo");
		img.src = worldPath + "./img/"+window.getComputedStyle(document.documentElement).getPropertyValue('--logo').split("#")[1] + ".png";
	}
};
userTips = {
	showTipWin: function (tipText, tipId) {
		//var tipWin, btnWrapper, okBtn, inputWrapper, hideId = "", hideLabel, hideInput, article;

		var tipWin = createDiv({css: "tip-win redTip"});
		var closeBtn = createButton({css: "btn btn-default close", text: "<i class = 'icon-Close'></i>"});
		closeBtn.style.opacity = 1;
		closeBtn.style.color = "white";
		closeBtn.onclick = function () {
			$(tipWin).remove();
		};
		tipWin.appendChild(closeBtn);
		var article = createArticle({});
		var hideId = tipId;
		if (localStorage.getItem("planinnsyn-" + hideId ) === null && globals.mapMode !== "kommuneplan") {
			if (globals.map.getLayerById("kp")) {
				article.appendChild(createSection({text: tipText}));
			}
		}
		tipWin.appendChild(article);

		var btnWrapper = createDiv({css: "tip-win-btn-wrapper"});
		var okBtn = createButton({css: "btn btn-default", text: "OK"});
		okBtn.onclick = function () {
			$(tipWin).remove();
		};
		btnWrapper.appendChild(okBtn);
		tipWin.appendChild(btnWrapper);

		var inputWrapper = createDiv({css:"tip-win-input-wrapper"});
		var hideInput = createImput({type: "checkbox", id: hideId});
		var hideLabel = createLabel({htmlfor: hideId, text: "Ikke vis igjen"});

		inputWrapper.appendChild(hideInput);
		inputWrapper.appendChild(hideLabel);
		tipWin.appendChild(inputWrapper);

		$(hideInput).change(function (e) {
			if (e.currentTarget.checked) {
				localStorage.setItem("planinnsyn-" + hideId, true);
			} else {
				localStorage.removeItem("planinnsyn-" + hideId);
			}
		});

		if ($(article).find("section").length > 0) {
			$("#map").append(tipWin);
			if (($(tipWin).height() + 60) > $(window).height()) {
				$(article).css("height", $(window).height() - 140);
			}
		}
	},
};
//vindu for å returnere til fagsystem ved GI kall med hint
giHint = {
	lagOmraade: function(searchStr, sesjon, url2){
		giHint.showHintWin("LagOmraade", url2, sesjon);
		let interactions = globals.map.getInteractions();
		// Slår på måle-/tegneverktøy
		if (interactions.mapClickInteraction) {
			interactions.mapClickInteraction.setActive(false);
		}
		globals.map.getInteractionById("mapclick").setActive(false);
		
		var vector = globals.map.getLayerByName("sketchLayer");
		var source = undefined;
		if (vector === null) {
			var style = new ol.style.Style({
				stroke: new ol.style.Stroke({
					color: "#ff0000",
					width: 3
				}),
				image: new ol.style.Circle({
					radius: 5,
					stroke: new ol.style.Stroke({
						color: "rgba(255, 0, 0, 1)"
					}),
					fill: new ol.style.Fill({
						color: "rgba(255, 255, 255, 0.2)"
					})
				})
			});
			var source = new ol.source.Vector();
			var vector = new ol.layer.Vector({
				title: "sketchLayer",
				layerId: "sketchLayer",
				source: source,
				style: style,
				zIndex: 1000,
			});
			globals.map.addLayer(vector);
		} else {
			source = vector.getSource();
		}
		var draw = new ol.interaction.Draw({
			source: source,
			type: "Polygon",
		});
		draw.set("itype", "draw");
		draw.on('drawstart', function(event){
			source.clear();
		});
		draw.on('drawend', function(event){
			var feature = event.feature;
			var style = new ol.style.Style({
				stroke: new ol.style.Stroke({
					color: "rgba(255, 0, 0, 1)",
					width: 3,
				}),
				image: new ol.style.Circle({
					radius: 5,
					stroke: new ol.style.Stroke({
						color: "rgba(255, 0, 0, 1)"
					}),
					fill: new ol.style.Fill({
						color: "rgba(255, 255, 255, 0.2)"
					})
				})
			});
			feature.setStyle(style);
			feature.changed();
			let valueObject = {};
			valueObject.kodeverdi = "0301";
			valueObject.kodebeskrivelse = "OSLO";
			valueObject.coordinates = feature.getGeometry().flatCoordinates;
			document.getElementById("giReturnBtn").value = JSON.stringify(valueObject);
		});
		draw.set("interactionId", "pointSelect");
		globals.map.addInteraction(draw);
	},
	lagPunkt: function(searchStr, sesjon, url2){
		giHint.showHintWin("LagPunkt", url2, sesjon);
		let interactions = globals.map.getInteractions();
		// Slår på måle-/tegneverktøy
		if (interactions.mapClickInteraction) {
			interactions.mapClickInteraction.setActive(false);
		}
		globals.map.getInteractionById("mapclick").setActive(false);
		
		var customInteractions = {};
		customInteractions.MapClick = function () {
			/**
			 * @type ol.interaction.Interaction.call
			 */
			ol.interaction.Interaction.call(this, {
				"handleEvent": function (mapBrowserEvent) {
					if (mapBrowserEvent.type === "singleclick") {
						document.getElementById("coordsCt").innerHTML = mapBrowserEvent.coordinate;
						let valueObject = {};
						valueObject.kodeverdi = "0301";
						valueObject.kodebeskrivelse = "OSLO";
						valueObject.x = mapBrowserEvent.coordinate[0];
						valueObject.y = mapBrowserEvent.coordinate[1];
						document.getElementById("giReturnBtn").value = JSON.stringify(valueObject);
						var clickFeature = new ol.Feature({
							name: "clickFeature",
							geometry: new ol.geom.Point(mapBrowserEvent.coordinate),
						});
						clickFeature.setStyle(new ol.style.Style({
							image: new ol.style.Icon({
								anchor: [0.5, 1],
								size: [32, 32],
								src: 'icons/Kart PinBlue.png',
							}),
						}));
						var markerlayer = globals.map.getLayerById("fontmarkers");
						markerlayer.getSource().clear();
						markerlayer.getSource().addFeature(clickFeature);
					}
				}
			});
		};
		ol.inherits(customInteractions.MapClick, ol.interaction.Interaction);
		var intr = new customInteractions.MapClick();
		intr.set("interactionId", "pointSelect");
		globals.map.addInteraction(intr);
	},
	lagDok: function(searchStr, sesjon, url2, hint){
		require(
		["js/plugins/DOKPlugin"], 
		function(dok){
			dok.initiate(hint, searchStr, url2, sesjon);
		});
	},
	showHintWin: function (hint, url2, sesjon) {
		//var tipWin, btnWrapper, okBtn, inputWrapper, hideId = "", hideLabel, hideInput, article;

		var tipWin = createDiv({css: "tip-win"});

		var article = createArticle({});
		article.appendChild(createSection({text: hint}));
		let coordsCt = createDiv({id: "coordsCt" });
		article.appendChild(coordsCt);
		let coordCheck = createInput({id: "coordCheck", type: "checkbox"});
		coordCheck.onclick = giHint.coordCheckClick;
		coordCheck.checked = true;
		let coordCheckLabel = createLabel({text: hint, htmlfor: "coordCheck"});
		article.appendChild(coordCheckLabel);
		article.appendChild(coordCheck);
		tipWin.appendChild(article);

		var btnWrapper = createDiv({css:"tip-win-btn-wrapper"});
		var okBtn = createDiv({id:"giReturnBtn", text: "Gå tilbake til fagsystemet", css: "btn btn-default"});
		okBtn.onclick = function () {
			$.ajax({
				url: encodeURI("http://diversus:8080/giKartBasisLagre/lagre?session=" + sesjon + "&hint=" + hint + "&data= " + okBtn.value),
				success:function(data){
					//window.location = url2;
				},
				error:function(){
					alert('An error was encountered.');
				}
			});
		};
		btnWrapper.appendChild(okBtn);
		tipWin.appendChild(btnWrapper);

		var inputWrapper = createDiv({css: "tip-win-input-wrapper"});
		inputWrapper.className = "tip-win-input-wrapper";
		
		tipWin.appendChild(inputWrapper);
		$("#map").append(tipWin);
		if (($(tipWin).height() + 60) > $(window).height()) {
			$(article).css("height", $(window).height() - 140);
		}
	},
	coordCheckClick: function(){
		let check = document.getElementById("coordCheck");
		let interactions = globals.map.getInteractions();
		if(check.checked){
			globals.map.getInteractionById("pointSelect").setActive(true);
			globals.map.getInteractionById("mapclick").setActive(false);
			if (interactions.mapClickInteraction) {
				interactions.mapClickInteraction.setActive(false);
			}
		}else{
			globals.map.getInteractionById("pointSelect").setActive(false);
			globals.map.getInteractionById("mapclick").setActive(true);
			if (interactions.mapClickInteraction) {
				interactions.mapClickInteraction.setActive(true);
			}
		}
	}
};
    
export default {
	createModule: function (allDom, conf) {
		/* Legger til kontekstspesifikke urler */
		var params = conf.parameters;
		var configs = conf.configs;
		Object.keys(params).forEach(function (p) {
			globals[p] = params[p];
		});

		configs.modes.forEach(function (mode){
			globals.modes[mode.mode] = mode;
		});
		
		if (conf.intranett) {
			$(".user-message-intranett").show();
			var cssFile = document.createElement('link');
			cssFile.rel = 'stylesheet';
			cssFile.href = worldPath + "./css/intranett.css";
			document.head.appendChild(cssFile);
		} else {
			$(".user-message-internett").show();
		}
		if(configs.activeTip){
			globals.waitAndThen(2000, userTips.showTipWin, configs.tipText, configs.tipId);
		}
		
		privateFns.setSiteAttributes(conf.site);
		mapFns.initiateMap(allDom.id, conf.configs);
		conf.loadplugins(globals.map, function(){
			argParser.getTokenAndParams();
			if (params.intranett) {
				$(".user-message-intranett").show();
			} else {
				$(".user-message-internett").show();
			}
		}, conf);
		privateFns.setColorScheme(conf.configs.colorScheme);
		globals.GIFunctions.LagOmraade = giHint.lagOmraade;
		globals.GIFunctions.LagPunkt = giHint.lagPunkt;
		globals.GIFunctions.LagDok = giHint.lagDok;
	}
};

